import { StackDirection } from "@chakra-ui/react";

import { mobileStyleBreakpoint } from "util/styleHelpers";

export const MODAL_PADDING_X = mobileStyleBreakpoint(4, 6);
export const MODAL_LINE_ITEM_STACK_DIRECTION =
  mobileStyleBreakpoint<StackDirection>("column", "row");
export const MODAL_LINE_ITEM_PADDING_Y = mobileStyleBreakpoint(4, 3);
